<script setup lang="ts">
import { computed, useSlots } from 'vue'
import { getAnalyticsTracker } from '@/tracking/analytics/plugin.ts'
import type { AnalyticsData } from '@/tracking/analytics/analyticsTracker.ts'

const props = withDefaults(defineProps<{
  isAccordionLayout?: boolean
  eventContext?: AnalyticsData
}>(), {
  isAccordionLayout: false,
  eventContext: () => ({})
})

defineSlots<{
  default(): unknown
  translation?(): unknown
  footer?(): unknown
}>()

getAnalyticsTracker().getChildContext(props.eventContext)

const slots = useSlots()
const hasFooter = computed(() => Boolean(slots.footer))

const SECTION_BORDER_CLASSES = 'border border-gray-300 shadow-sm'

const panelClasses = computed(() =>
  props.isAccordionLayout ? 'mt-2 rounded-b-xs border border-gray-600' : 'rounded-xs'
)
const bodyClasses = computed(() =>
  props.isAccordionLayout ? '' : `${SECTION_BORDER_CLASSES} rounded-t-xs border-b-0`
)
const footerSectionClasses = computed(() =>
  props.isAccordionLayout ? '' : '[&>*]:border-x [&>*]:border-gray-300 [&>*]:shadow-sm'
)
</script>

<template>
  <div class="mb-5 shadow-sm" :class="panelClasses" data-testid="big-goal">
    <div class="p-4 text-text-2xl font-regular leading-8" :class="bodyClasses" data-testid="big-goal-body">
      <slot />
      <slot name="translation" />
    </div>
    <div
      v-if="hasFooter"
      class="[&>*]:relative [&>*]:border-b-2 [&>*]:border-b-gray-400 [&>*]:bg-white"
      :class="footerSectionClasses"
      data-testid="big-goal-footer"
    >
      <slot name="footer" />
    </div>
  </div>
</template>
